module.exports = __webpack_public_path__ + "970cea555bf6733016cef0ad049ea0db.jpg";